import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllSections = () =>
  apiClient.get(`${REST_API_BASE_URL}/sections`);

export const saveSection = (section) =>
  apiClient.post(`${REST_API_BASE_URL}/section`, section);

export const getSection = (sectionid) =>
  apiClient.get(`${REST_API_BASE_URL}/section/${sectionid}`);

export const updateSection = (id, section) =>
  apiClient.put(`${REST_API_BASE_URL}/section/${id}`, section);

export const deleteSection = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/section/${id}`);

export default apiClient;
